const selectors = {
  ITEM_SELECTOR: '.js-accordion-item',
  BUTTON_SELECTOR: '.js-accordion-button',
  CONTENT_SELECTOR: '.js-accordion-content',
  HEADING_BUTTON_CLASS: '.js-accordion-button .text'
}

class AccordionList extends HTMLElement {
  constructor() {
    super()

    this.init()
  }

  close(items) {
    items.forEach((item) => {
      const content = item.querySelector(selectors.CONTENT_SELECTOR)
      const button = item.querySelector(selectors.BUTTON_SELECTOR)

      if (button && content) {
        content.style.maxHeight = '0px'
        button.setAttribute('aria-expanded', 'false')
        item.removeAttribute('open')
      }
    })
  }

  open(item) {
    const content = item.querySelector(selectors.CONTENT_SELECTOR)
    const button = item.querySelector(selectors.BUTTON_SELECTOR)

    content.style.maxHeight = content.children[0].scrollHeight + 'px'
    button.setAttribute('aria-expanded', 'true')
    item.setAttribute('open', true)
  }

  toggleDescription(item, list) {
    if (item && !item.hasAttribute('open')) {
      this.close(list)
      this.open(item)
    } else {
      this.close(list)
    }
  }

  init() {
    const list = this.querySelectorAll(selectors.ITEM_SELECTOR)

    if (list.length) {
      list.forEach((item) => {
        const button = item.querySelector(selectors.BUTTON_SELECTOR)
        const textTitle = item.querySelector(selectors.HEADING_BUTTON_CLASS)

        if (textTitle) {
          textTitle.innerHTML = textTitle.innerHTML.replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1 + m2.toLowerCase())
        }

        if (item.hasAttribute('open')) {
          this.open(item)
        }

        if (button) {
          const _this = this

          button.onclick = function (e) {
            if (location.pathname.includes('store-locator')) {
              e.stopPropagation()
            }
            _this.toggleDescription(item, list)
          }
        }
      })
    }
  }
}

if (!customElements.get('accordion-list')) {
  customElements.define('accordion-list', AccordionList)
}
